import { render, staticRenderFns } from "./NetworkStatus.vue?vue&type=template&id=59e58030&scoped=true&"
import script from "./NetworkStatus.vue?vue&type=script&lang=js&"
export * from "./NetworkStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e58030",
  null
  
)

export default component.exports